// ContentLanguage — Session 19AE.
//
// Tells the LLM which language(s) to use for generated content. Set at course
// creation time and locked for the course's lifetime (changing language mid-
// course would mean invalidating IngestPackage). Affects every generative
// stage's prompt via prompts.ts LANGUAGE_MODE_RULES.
//
// 4 modes — calibrated for Chinese students preparing for English exams:
//
//   en              纯英语. Pure English content. Used for fully English-language
//                   programs (HKU undergrad, exchange, English-medium degrees).
//
//   en_zh_gloss     英语主导 + 中文释义. Question stems / explanations / model
//                   answers in English. Key terms parenthetically glossed in
//                   Chinese on first occurrence — helps comprehension without
//                   replacing the English exam vocabulary.
//
//   zh_en_terms     中文主导 + 英文术语. Explanations / scaffolding in Chinese.
//                   Domain terminology kept in English original (e.g. "对偶
//                   性 (duality)"). Useful when the exam uses Chinese but
//                   sources cite English papers.
//
//   zh              纯汉语. All-Chinese, no English. Used for domestic Chinese
//                   programs where exam, source, and study all happen in zh.
//
// Why not field-level dual (e.g. question_en + question_zh):
//   - Doubles output token cost (generation = ¥)
//   - Doubles UI complexity (every component must pick which to display)
//   - LLM accuracy drops at dual-output (more chances to drift between langs)
// Decision: single-string fields, content shape governed by mode.
import { z } from 'zod';
export const ContentLanguageSchema = z.enum([
    'en',
    'en_zh_gloss',
    'zh_en_terms',
    'zh',
]);
export const ALL_CONTENT_LANGUAGES = [
    'en',
    'en_zh_gloss',
    'zh_en_terms',
    'zh',
];
export const DEFAULT_CONTENT_LANGUAGE = 'en_zh_gloss';
/** Human-readable description for UI / prompt embedding. */
export const CONTENT_LANGUAGE_DESCRIBE = {
    en: {
        zh: '纯英语 — 题目、解释、范文全英',
        en: 'Pure English — questions, explanations, model answers all in English',
    },
    en_zh_gloss: {
        zh: '英语主导 + 中文释义 — 主体英文，关键术语括注中文',
        en: 'English-dominant + Chinese gloss — body English, key terms parenthetically glossed in Chinese',
    },
    zh_en_terms: {
        zh: '中文主导 + 英文术语 — 解释中文，专业词保留英文原文',
        en: 'Chinese-dominant + English terms — explanations in Chinese, domain terms kept as English originals',
    },
    zh: {
        zh: '纯汉语 — 全中文，无英文',
        en: 'Pure Chinese — all in Chinese, no English',
    },
};
//# sourceMappingURL=content-language.js.map